import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
        <div className="flex-1 text-center lg:text-left">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            {appData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            {appData.description}
          </p>
          <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
            {appData.features.map((feature, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-check-line"></i>
                </span>
                {feature}
              </span>
            ))}
          </div>
        </div>
        <div className="flex-shrink-0">
          <div className="bg-background-50 rounded-2xl p-3 shadow-sm w-[240px]">
            <div className="bg-background-200 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-3">
                <span className="w-2.5 h-2.5 rounded-full bg-red-400"></span>
                <span className="w-2.5 h-2.5 rounded-full bg-yellow-400"></span>
                <span className="w-2.5 h-2.5 rounded-full bg-green-400"></span>
              </div>
              <div className="space-y-2">
                <div className="bg-background-50 rounded h-2 w-3/4"></div>
                <div className="bg-background-50 rounded h-2 w-full"></div>
                <div className="bg-background-50 rounded h-2 w-5/6"></div>
                <div className="bg-background-50 rounded h-32 mt-3 flex items-center justify-center">
                  <span className="w-10 h-10 flex items-center justify-center text-primary-400">
                    <i className="ri-magic-line text-2xl"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}